// ============================================================
// KpiCard — Kennzahlen-Kachel mit optionalem Delta
// ============================================================

import type { ReactNode } from 'react';
import { CO } from '../theme';
import { Info } from './ui';

export interface KpiCardProps {
  label: ReactNode;
  value: ReactNode;
  tone?: 'pos' | 'neg' | 'einsatz' | 'auszahlung';
  info?: string;
  big?: boolean;
  sub?: ReactNode;
  delta?: ReactNode;
}

export function KpiCard({ label, value, tone, info, big, sub, delta }: KpiCardProps) {
  const toneColor =
    tone === 'neg'
      ? CO.neg
      : tone === 'pos'
        ? CO.pos
        : tone === 'einsatz'
          ? CO.einsatz
          : tone === 'auszahlung'
            ? CO.auszahlung
            : CO.text;
  return (
    <div
      style={{
        background: CO.card,
        border: `1px solid ${CO.border}`,
        borderLeft: `4px solid ${tone ? toneColor : CO.border}`,
        borderRadius: 12,
        padding: big ? '18px 20px' : '15px 18px',
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          fontSize: 12.5,
          color: CO.muted,
          fontWeight: 500,
        }}
      >
        {label}
        {info ? <Info text={info} /> : null}
      </div>
      <div
        className="num"
        style={{
          fontSize: big ? 30 : 22,
          fontWeight: 700,
          color: toneColor,
          letterSpacing: '-.5px',
          lineHeight: 1.05,
        }}
      >
        {value}
      </div>
      {sub ? (
        <div className="num" style={{ fontSize: 12, color: CO.faint }}>
          {sub}
        </div>
      ) : null}
      {delta != null ? (
        <div className="num" style={{ fontSize: 12, color: CO.muted, marginTop: 2 }}>
          <span style={{ color: CO.faint }}>ggü. Vorzeitraum: </span>
          <span style={{ fontWeight: 600, color: CO.text }}>{delta}</span>
        </div>
      ) : null}
    </div>
  );
}
